import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-base pt-8" }
const _hoisted_2 = { class: "flex gap-6 w-full" }
const _hoisted_3 = { class: "flex flex-wrap w-2/3" }
const _hoisted_4 = {
  key: 0,
  class: "activoty-summary-block border border-gray-200 rounded-2xl bg-white shadow-card w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "activoty-summary-block border border-gray-200 rounded-2xl bg-white shadow-card w-full"
}
const _hoisted_6 = { class: "meeting-engagement-requirements-block border border-gray-200 rounded-2xl p-6 bg-white shadow-card w-1/3 relative" }
const _hoisted_7 = { class: "absolute top-5 right-5" }
const _hoisted_8 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_9 = { class: "mb-1 text-gray-900 font-semibold text-lg" }
const _hoisted_10 = { class: "text-gray-600 text-sm mb-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-5" }, null, -1)
const _hoisted_12 = { class: "flex flex-col mb-5" }
const _hoisted_13 = { class: "font-medium text-gray-900 text-sm" }
const _hoisted_14 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_15 = { class: "bg-gray-200 rounded-full h-[8px] min-w-36 w-full" }
const _hoisted_16 = { class: "flex flex-col mb-5" }
const _hoisted_17 = { class: "font-medium text-gray-900 text-sm" }
const _hoisted_18 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_19 = { class: "bg-gray-200 rounded-full h-[8px] min-w-36 w-full" }
const _hoisted_20 = { class: "flex flex-col mb-5" }
const _hoisted_21 = { class: "font-medium text-gray-900 text-sm" }
const _hoisted_22 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_23 = { class: "bg-gray-200 rounded-full h-[8px] min-w-36 w-full" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "font-medium text-gray-900 text-sm" }
const _hoisted_26 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_27 = { class: "bg-gray-200 rounded-full h-[8px] min-w-36 w-full" }

import { ref, computed, onBeforeMount } from "vue";
import { useActivityStore } from "@/stores/activityStore";
import ActivitySummaryPerClassComponent from "../components/ActivitySummaryPerClassComponent.vue";
import ActivitySummaryPerStudentComponent from "../components/ActivitySummaryPerStudentComponent.vue";
import { useFilterStore } from "@/stores/filterStore";
import { useLearnerStore } from "@/stores/learnerStore";
import tooltip from "@/components/global/TooltipComponent.vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import moment from "moment";

import FiltersOutOfDateComponent from "@/modules/main/components/FiltersOutOfDateComponent.vue";
import LoadingSpinnerComponent from "@/modules/main/components/LoadingSpinnerComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityView',
  setup(__props) {

const activityStore = useActivityStore();
const filterStore = useFilterStore();
const learnerStore = useLearnerStore();

// Reactive variables
const dates = ref<string[]>([]);
const x_axis_month = ref("");

// On before mount hook
onBeforeMount(async () => {
  generateDatesForCurrentMonth();

  const studentsWithoutClasses = learnerStore.getSchoolLearners.filter(
    (student) => student.classes == null
  );
});

// Generate progress bar background for activity cards
const engagementColours = (percentage: number) => {
  // Red Color
  if (percentage <= 50) {
    return "bg-red-300";
  }

  // Yellow Color
  if (percentage > 50 && percentage < 80) {
    return "bg-yellow-400";
  }

  // Green Color
  if (percentage >= 80) {
    return "bg-emerald-200";
  }

  if (percentage >= 100) {
    return "bg-green-300";
  }
};

// Generate dates for the current month
const generateDatesForCurrentMonth = () => {
  const year = moment().year();
  // 0-indexed, so 0 is January and 11 is December
  // August (0-indexed, so 7 represents August)
  const month = moment().month() - 1;
  // August (0-indexed, so 7 represents August)
  //const month = 7;

  x_axis_month.value = moment().month(month).format("MMMM");

  const startOfMonth = moment([year, month]);
  const endOfMonth = startOfMonth.clone().endOf("month");

  // Clear any existing dates
  dates.value = [];

  for (let day = 0; day <= endOfMonth.date(); day++) {
    const date = startOfMonth.clone().add(day, "days");

    // Check if the date is within the correct month
    if (date.month() === month) {
      const formattedDate = date.format("YYYY-MM-DD");
      dates.value.push(formattedDate);
    }
  }
};

// functionailty for the summary data per student
const summaryDataPerStudent = computed(() => {
  return activityStore?.getActivitySummaryPerStudent as unknown as any[];
});

let mappedSummaryDataPerStudent = computed(() => {
  if (summaryDataPerStudent.value) {
    return summaryDataPerStudent.value.map((item) => ({
      userId: item.uid,
      userName: item.firstName + " " + item.lastName,
      averageLearningTimeMonth: Math.floor(item.averageLearningTime),
      averageLearningTimeWeek: Math.floor(item.averageLearningTimeLast7Days),
      percentageDailyTasksCompletionMonth:
        item.dailyTasksCompletionMostRecentMonth,
      percentageDailyTasksCompletionWeek:
        item.dailyTasksCompletionMostRecentWeek,
    }));
  } else {
    return [];
  }
});

// Helper function to get the start of the week (Monday)
function getStartOfWeek(date: Date): Date {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday (0)
  return new Date(d.setDate(diff));
}

// Function to generate the last 4 weeks' start dates
function getLastFourWeeks(): string[] {
  const today = new Date();
  const weeks = [];

  for (let i = 0; i < 4; i++) {
    const startOfWeek = getStartOfWeek(today);
    weeks.unshift(startOfWeek.toISOString().slice(0, 10)); // Add weeks in reverse order
    today.setDate(today.getDate() - 7); // Move back one week
  }

  return weeks;
}

// Generate the last 4 weeks dynamically
const lastFourWeeks = getLastFourWeeks();

// Computed property to get all engagement data
const getAllEngagementData = computed(() => {
  return (
    activityStore.getActivityData?.weeklyEngagementPercentage?.map(
      (entry: { week: string; percentage: number }) => ({
        week: entry.week, // Keep this as raw date for matching
        displayWeek: new Date(entry.week).toLocaleDateString("en-ZA", {
          day: "numeric",
          month: "long",
        }),
        percentage: Math.min(entry.percentage, 100), // Limit percentage to 100
      })
    ) || []
  );
});

// Function to match existing data with calculated weeks
function matchDataWithWeeks(
  data: Array<{ week: string; percentage: number }>,
  weeks: string[]
) {
  return weeks.map((week) => {
    const foundWeek = data.find((entry) => entry.week === week);
    return {
      week, // Keep ISO week format for internal use
      displayWeek: foundWeek
        ? foundWeek.week
        : new Date(week).toLocaleDateString("en-ZA", {
          day: "numeric",
          month: "long",
        }),
      percentage: foundWeek ? foundWeek.percentage : 0, // Default to 0 if no data
    };
  });
}

// Match the engagement data with the last 4 weeks
const engagementRequirementsData = computed(() => {
  return matchDataWithWeeks(getAllEngagementData.value, lastFourWeeks);
});

// Computed properties for week percentages
const weekOnePercentage = computed(
  () => engagementRequirementsData.value[0]?.percentage || 0
);
const weekTwoPercentage = computed(
  () => engagementRequirementsData.value[1]?.percentage || 0
);
const weekThreePercentage = computed(
  () => engagementRequirementsData.value[2]?.percentage || 0
);
const weekFourPercentage = computed(
  () => engagementRequirementsData.value[3]?.percentage || 0
);

// Computed properties for week dates
const weekOneDate = computed(
  () => engagementRequirementsData.value[0]?.displayWeek || "N/A"
);
const weekTwoDate = computed(
  () => engagementRequirementsData.value[1]?.displayWeek || "N/A"
);
const weekThreeDate = computed(
  () => engagementRequirementsData.value[2]?.displayWeek || "N/A"
);
const weekFourDate = computed(
  () => engagementRequirementsData.value[3]?.displayWeek || "N/A"
);

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('activity_view.header'),
      filterVariant: "gradeSubject",
      includeAll: false
    }, null, 8, ["pageHeading"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (
          _unref(filterStore).selectedFilters.classGroup &&
          _unref(filterStore).selectedFilters.classGroup.length > 0
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_unref(activityStore).loader.fetchActivitySummaryPerStudent === false)
                  ? (_openBlock(), _createBlock(ActivitySummaryPerStudentComponent, {
                      key: 0,
                      mappedSummaryDataPerStudent: _unref(mappedSummaryDataPerStudent)
                    }, null, 8, ["mappedSummaryDataPerStudent"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(activityStore).loader.fetchActivitySummaryPerClassData === false)
                  ? (_openBlock(), _createBlock(ActivitySummaryPerClassComponent, { key: 0 }))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(LoadingSpinnerComponent),
            _createVNode(FiltersOutOfDateComponent),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_8, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-info-circle',
                  title: 'rl info circle',
                  "aria-hidden": "true"
                })
              ])), [
                [
                  _directive_tooltip,
                  _ctx.$t('activity_view.tooltips.meeting_engagement_requirements'),
                  "left",
                  { tooltip: true }
                ]
              ])
            ]),
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("activity_view.metting_engagement_requirement_card.header")), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("activity_view.metting_engagement_requirement_card.subheader")), 1),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(weekOneDate.value), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: _normalizeClass(engagementColours(Math.min(Number(weekOnePercentage.value), 100)) +
                  ' h-[8px] rounded-full'
                  ),
                    style: _normalizeStyle('width: ' + weekOnePercentage.value + '%')
                  }, null, 6)
                ]),
                _createElementVNode("span", null, _toDisplayString(weekOnePercentage.value.toFixed(0)) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(weekTwoDate.value), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(engagementColours(Math.min(Number(weekTwoPercentage.value), 100)) +
                  ' h-[8px] rounded-full'
                  ),
                    style: _normalizeStyle('width: ' + weekTwoPercentage.value + '%')
                  }, null, 6)
                ]),
                _createElementVNode("span", null, _toDisplayString(weekTwoPercentage.value.toFixed(0)) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("p", _hoisted_21, _toDisplayString(weekThreeDate.value), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(engagementColours(
                  Math.min(Number(weekThreePercentage.value), 100)
                ) + ' h-[8px] rounded-full'
                  ),
                    style: _normalizeStyle('width: ' + weekThreePercentage.value + '%')
                  }, null, 6)
                ]),
                _createElementVNode("span", null, _toDisplayString(weekThreePercentage.value.toFixed(0)) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(weekFourDate.value), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: _normalizeClass(engagementColours(Math.min(Number(weekFourPercentage.value), 100)) +
                  ' h-[8px] rounded-full'
                  ),
                    style: _normalizeStyle('width: ' + weekFourPercentage.value + '%')
                  }, null, 6)
                ]),
                _createElementVNode("span", null, _toDisplayString(weekFourPercentage.value.toFixed(0)) + "%", 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})